/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Alert, Slide, Stack } from '@mui/material';
import QueryString from 'qs';
import { useSnackbar } from 'notistack';
import { forwardRef } from 'react';
import FormProvider from '../hook-form/form-provider';
import { encryptRequest, decryptResponse } from '@/app/utilities/helpers/security';
import { axiosInstance } from '@/app/utilities/helpers/axios';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function PlaylistDelete({ device, refresh, selectedPlaylist, dialog }) {
  const { enqueueSnackbar } = useSnackbar();

  const methods = useForm();

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async () => {
    try {
      const body = {
        data: encryptRequest({
          device_id: device.app_device_id,
          playlist_id: selectedPlaylist ? selectedPlaylist._id : -1,
        }),
      };

      const response = await axiosInstance.post(
        '8Pb8VrSBnL4Vmy6j8549MF5hFCCdxrzc',
        QueryString.stringify(body)
      );

      const responseData = decryptResponse(response.data);

      if (responseData.success) {
        enqueueSnackbar(responseData.message, { variant: 'success' });
        refresh();
      } else {
        enqueueSnackbar(responseData.message, { variant: 'error' });
      }
      dialog.onFalse();
    } catch (error) {
      enqueueSnackbar('Server Error', { variant: 'error' });
      dialog.onFalse();
    }
  });

  return (
    <Dialog
      keepMounted={false}
      open={dialog.value}
      onClose={dialog.onFalse}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
    >
      <DialogTitle sx={{ pb: 2 }}>Confirmation</DialogTitle>

      <DialogContent>
        <FormProvider methods={methods} onSubmit={onSubmit}>
          <Stack gap={3} marginTop={2}>
            <Stack gap={2}>
              <Stack>
                <Alert severity="warning">Are you sure you will delete this playlist</Alert>
              </Stack>
            </Stack>
            <Stack gap={3} flexDirection="row" justifyContent="flex-end" marginBottom={2}>
              <Button onClick={dialog.onFalse}>Cancel</Button>
              <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
                Ok
              </LoadingButton>
            </Stack>
          </Stack>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
